import type { TabItem } from '../types/tabs';

interface TabBarProps {
  tabs: TabItem[];
  activeTabId: string | null;
  onTabClick: (tabId: string) => void;
  onTabClose: (tabId: string) => void;
}

export default function TabBar({ tabs, activeTabId, onTabClick, onTabClose }: TabBarProps) {
  const getTabIcon = (tab: TabItem) => {
    switch (tab.type) {
      case 'table':
        return '📊';
      case 'flowsheet':
        return '🔗';
      case 'predictor_model':
        return 'M';
      case 'optimization':
        return '🎯';
      case 'data':
        return '📄';
      case 'pdf':
        return '📑';
      default:
        return '📄';
    }
  };

  return (
    <div className="w-20 flex items-center justify-center py-8 px-2 flex-shrink-0">
      <div 
        className="rounded-full shadow-lg border border-white/20 flex flex-col items-center py-6 px-2 gap-3"
        style={{ backgroundColor: 'rgba(30, 156, 215, 0.6)' }}
      >
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className="relative group"
          >
            <button
              className={`w-12 h-12 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-200 ${
                activeTabId === tab.id
                  ? 'bg-white text-blue-600 shadow-md'
                  : 'bg-white/20 text-white hover:bg-white/30'
              }`}
              title={tab.file_name || 'Untitled'}
              onClick={() => onTabClick(tab.id)}
            >
              {getTabIcon(tab)}
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onTabClose(tab.id);
              }}
              className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-500 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
              title="Close tab"
              style={{ lineHeight: '1' }}
            >
              <span className="text-sm leading-none">×</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
